/**
 * Normalize a user-supplied website URL for use as an href.
 *
 * - http(s) URLs are returned as-is
 * - scheme-less values (e.g. "example.com") are prefixed with https://
 * - anything with another scheme (javascript:, data:, etc.) returns null
 */
export const toSafeHref = (url?: string | null): string | null => {
  const trimmed = url?.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Reject any other scheme (a "host:port" value like example.com:8080 is not a scheme)
  if (/^[a-z][a-z0-9+.-]*:(?!\d)/i.test(trimmed)) return null;
  return `https://${trimmed.replace(/^\/+/, '')}`;
};
